module.exports = __webpack_public_path__ + "static/media/29ADMSPC3.e7b9119b.jpg";